<template>
  <div id="app">
    <h1 class="logo">SHAIA</h1>
    <span class="slogan">{{ slogan }}</span>
  </div>
</template>

<script>
const SLOGAN = 'Solace in technology ∘ Belief in the future'

export default {
  name: 'app',
  data () {
    return {
      slogan: SLOGAN
    }
  }
}
</script>

<style>
@import url("https://unpkg.com/normalize.css@8.0.0/normalize.css");
@import url("https://use.typekit.net/rlr4qfv.css");

body {
  display: flex;
  height: 100vh;
  user-select: none;
}

#app {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.logo {
  color: #000;
  font-family: 'filson-pro', sans-serif;
  font-size: 6.5em;
  font-weight: 100;
  letter-spacing: 0.1618em;
  line-height: 1rem;
  padding-left: 0.1618em;
}

.slogan {
  background-color: #000;
  color: #fff;
  font-family: 'base-mono-wide', monospace;
  font-size: 0.8rem;
  font-weight: 400;
  display: inline-block;
  text-transform: uppercase;
  padding: 0.75em 1.25em;
}
</style>
